import React, { PureComponent } from 'react'
import { Modal, Col, Table, Button, Tooltip, OverlayTrigger, FormGroup } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputCheckBox from '../../commons/form/InputCheckBox'
import FinancingTypeModalPage from '../../../containers/masters/FinancingTypeModalPage'
class FinancingMasterModalProduct extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  fetchProductList (value) {
    this.props.actions.fetchFinancingProductCompany(this.props.financing.financingCompanyId, { ...this.props.filter, page: value })
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFinancingProductCompany(this.props.financing.financingCompanyId, { ...this.props.filter, orderBy: `-${field}` })
        break
      case `-${field}`:
        this.props.actions.fetchFinancingProductCompany(this.props.financing.financingCompanyId, { ...this.props.filter, orderBy: `+${field}` })
        break
      default:
        this.props.actions.fetchFinancingProductCompany(this.props.financing.financingCompanyId, { ...this.props.filter, orderBy: `-${field}` })
        break
    }
  }

  componentDidUpdate () {
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.financing != null && this.props.financing.financingCompanyId !== prevProps.financing?.financingCompanyId) {
      this.props.actions.fetchFinancingProductCompany(this.props.financing.financingCompanyId, this.props.filter)
    }
    return null
  }

  cleanUoCOmbo () {
    this.props.reset()
  }

  render () {
    const {
      t,
      showModal, productList, productListCount, pagesCount, financing
      , actions: { deleteFinancingTypeModal, closeEditFinancingModalProduct, recoverFinancingTypeModal, openFinancingTypeModal }, filter: { page }
    } = this.props
    const tKey = 'MASTERS.FINANCING_MASTERS.MODAL_PRODUCT.'
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const finName = financing?.name
    return (
      <>
        <FinancingTypeModalPage/>
        <Modal id="financingMasterModalProduct" className="_nf" show={showModal} onHide={closeEditFinancingModalProduct}>
          <form autoComplete="off" >
            <Modal.Header closeButton onHide={closeEditFinancingModalProduct}>
              <Modal.Title>{t(`${tKey}TITLE`)} - {finName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormGroup>
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('name') }}>
                        {t(`${tKey}NAME`)}
                        <i className={this.getSortIcon('name')} />
                      </th>
                      <th onClick={() => { this.changeOrder('description') }}>
                        {t(`${tKey}DESCRIPTION`)}
                        <i className={this.getSortIcon('description')} />
                      </th>
                      <th onClick={() => { this.changeOrder('financingTypeProduct') }}>
                        {t('MASTERS.FINANCING_TYPE_PRODUCT.FINANCING_TYPE_PRODUCT')}
                        <i className={this.getSortIcon('financingTypeProduct')} />
                      </th>
                      <th className='actions' onClick={() => { this.changeOrder('reactivable') }}>
                        {t(`${tKey}REACTIVABLE`)}
                        <i className={this.getSortIcon('reactivable')} />
                      </th>
                      <th className='actions' onClick={() => { this.changeOrder('repurchaseAgreement') }}>
                        {t('MASTERS.FINANCING_TYPE_PRODUCT.REPURCHASE')}
                        <i className={this.getSortIcon('repurchaseAgreement')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productList && productList.map((product, idx) => {
                      return (
                        <tr key={idx} className={(product.isDeleted ? 'is-deleted' : '')}>
                          <td className={(product.isDeleted ? 'is-deleted' : '')}>{product.name}</td>
                          <td className={(product.isDeleted ? 'is-deleted' : '')}>{product.description}</td>
                          <td className={(product.isDeleted ? 'is-deleted' : '')}>{product.financingTypeProduct}</td>
                          <td className={'actions' + (product.isDeleted ? 'is-deleted' : '')}>
                            {
                              <Field
                                component={InputCheckBox}
                                colWidth={100} // 25, 33, 50, 75, 100 default=25
                                name={'selectedCheck_' + product.financingTypeId}
                                checked = {product.reactivatable}
                                disabled= {true}
                                id={'selectedCheck_' + product.financingTypeId}
                              />}
                          </td>
                          <td className={'actions' + (product.isDeleted ? 'is-deleted' : '')}>
                            {
                              <Field
                                component={InputCheckBox}
                                colWidth={100} // 25, 33, 50, 75, 100 default=25
                                name={'selectedCheckRP_' + product.financingTypeId}
                                checked = {product.repurchaseAgreement}
                                disabled= {true}
                                id={'selectedCheckRP_' + product.financingTypeId}
                              />}
                          </td>
                          <td className={'actions' + (product.isDeleted ? 'is-deleted' : '')}>
                            {!product.isDeleted ? (
                              <div>
                                <OverlayTrigger placement="left" overlay={editTooltip}>
                                  <a className='_Btn accept stk o-icn ' id="editProductFinancingCompany" onClick={() => openFinancingTypeModal(product.financingTypeId, this.props.financing, product.financingTypeId)}>
                                    <i className="iDocIcon-edit" />
                                  </a>
                                </OverlayTrigger>
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn ' id="deleteProductFinancingCompany" onClick={() => deleteFinancingTypeModal(product.financingTypeId, this.props.financing.financingCompanyId)}>
                                    <i className="iDocIcon-delete-forever" />
                                  </a>
                                </OverlayTrigger>
                              </div>
                            ) : (
                              <OverlayTrigger placement="left" overlay={recoverTooltip}>
                                <a className='_Btn accent stk o-icn ' onClick={() => recoverFinancingTypeModal(product.financingTypeId, this.props.financing.financingCompanyId)}>
                                  <i className='iDocIcon-undo-back' />
                                </a>
                              </OverlayTrigger>
                            )}
                          </td>
                        </tr>)
                    })
                    }
                    {(productList === null || productList === undefined || productList.length === 0) &&
                      <tr>
                        <td colSpan={12}><p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p></td>
                      </tr>
                    }
                  </tbody>
                </Table>

                <div className="section-users-footer">
                  <nav key={1} className="text-center">
                    <IDocCarPagination
                      id="btn_pag_Products"
                      page={page}
                      pagesCount={pagesCount}
                      totalRows={productListCount}
                      onSelectAction={(value) => this.fetchProductList(value)}
                    />
                  </nav>
                </div>
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Col sm={12} className="btn-wrapper">
                <Button
                  id="role-modal-submit-button"
                  className="_Btn new"
                  type="button"
                  onClick={() => openFinancingTypeModal(null, this.props.financing, null)}>
                  <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD`)}
                </Button>
              </Col>
            </Modal.Footer>
          </form>
        </Modal>
      </>
    )
  }
}

export default reduxForm({
  form: 'financingMasterModalProduct'
})(FinancingMasterModalProduct)
